import React, {Component} from 'react';
import './GuestlistScreen.css';
import PortalScreen from "../PortalScreen";
import axios from 'axios';
import RmButton from "../../Common/RmButton";
import {Redirect} from "react-router-dom";
import GuestlistRepo from "./GuestlistRepo";
import GuestlistScreenCategory from "./GuestlistScreenCategory";
import RmField from "../../Forms/RmField";
import Fuse from 'fuse.js';
import ErrorMessage from "../../Common/ErrorMessage";
import ArrowLink from "../../Common/ArrowLink";

export default class GuestlistScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingGuests: false,
            guestList: [],
            guests: [],
            redirectTo: null,
            guestCount: 0,
            searchText: "",
            searchFilter: GuestlistScreen.FILTER_ALL
        };

        this.filterOptions = { };
        this.filterOptions[GuestlistScreen.FILTER_ALL] = "Alles";
        this.filterOptions[GuestlistScreen.FILTER_SENT] = "Alleen verzonden";
        this.filterOptions[GuestlistScreen.FILTER_NON_SENT] = "Alleen niet verzonden";
    }

    componentDidMount() {
        this.refreshGuestList();
    }

    applyFilters() {
        this.processGuestList(this.state.guests);
    }

    processGuestList(sGuests) {
        let originalList = sGuests.slice();
        let nextGuestList = { };

        // Fuse search
        if (this.state.searchText) {
            let fuse = new Fuse(sGuests, {
                shouldSort: true,
                threshold: 0.6,
                location: 0,
                distance: 100,
                maxPatternLength: 32,
                minMatchCharLength: 1,
                keys: [
                    "name_first",
                    "name_last",
                    "address_line",
                    "address_postcode",
                    "address_locality",
                    "category_name"
                ]
            });

            sGuests = fuse.search(this.state.searchText);
        }

        sGuests.forEach((guest) => {
            let catName = guest["category_name"];

            if (!catName) {
                catName = "Algemeen";
            }

            if (typeof nextGuestList[catName] === "undefined") {
                nextGuestList[catName] = [];
            }

            nextGuestList[catName].push(guest);
        });

        this.setState({
            guests: originalList,
            guestList: nextGuestList,
            guestCount: originalList.length
        });
    }

    refreshGuestList() {
        if (this.state.loadingGuests) {
            return;
        }

        this.setState({
            loadingGuests: true
        });

        axios.get('/guests')
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.processGuestList(data.guests);

                    if (data.categories) {
                        GuestlistRepo.setCategoryNames(data.categories);
                    }
                }
            })
            .catch((err) => {
                console.error('Guest list GET, error caught:', err);
            })
            .then(() => {
                this.setState({
                    loadingGuests: false
                });
            });
    }

    handleAddGuestClick() {
        this.setState({
            redirectTo: "/gasten/toevoegen"
        });
    }

    handleAddGuestsClick() {
        this.setState({
            redirectTo: "/gasten/batch"
        });
    }

    handleSearchTextChange(value) {
        this.setState({
            searchText: value
        });

        setTimeout(() => {
            this.applyFilters();
        }, 0);
    }

    handleSearchFilterChange(value) {
        this.setState({
            searchFilter: value
        });

        setTimeout(() => {
            this.applyFilters();
        }, 0);
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo}/>;
        }

        let categories = [];
        let anyResults = false;

        for (let categoryName in this.state.guestList) {
            if (this.state.guestList.hasOwnProperty(categoryName)) {
                let guestArray = this.state.guestList[categoryName];

                if (guestArray && guestArray.length) {
                    categories.push(<GuestlistScreenCategory categoryName={categoryName}
                                                             guestEntries={guestArray}
                                                             isSearching={this.state.searchText ||
                                                             this.state.searchFilter !== GuestlistScreen.FILTER_ALL}
                                                             key={categoryName}
                    />);
                    
                    anyResults = true;
                }
            }
        }

        return (
            <PortalScreen tab={"gasten"} title={"Genodigdenlijst"} subText={"Voer hier naam- en adresgegevens in van de mensen die naar de uitvaart mogen komen."}
                          isLoading={this.state.loadingGuests}>
                <div className={"GuestlistScreen"}>
                    <div className={"GuestlistScreen__top-controls"}>
                        <div className={"GuestlistScreen__top-controls-buttons"}>
                            <RmButton label={"Genodigde toevoegen"} onClick={this.handleAddGuestClick.bind(this)}/>
                            <RmButton label={"Snel namen toevoegen"} className={"QuickAddLink"} onClick={this.handleAddGuestsClick.bind(this)}/>
                        </div>
                        {!this.state.loadingGuests && this.state.guestCount > 0 &&
                        <p className={"generic"}>Er zijn op dit
                            moment <strong>{this.state.guestCount}</strong> genodigden toegevoegd aan de lijst. Klik op een persoon voor details en opties.</p>
                        }
                    </div>

                    <hr className={"GuestlistScreen__hr"}/>

                    <div className={"GuestlistScreen__filter"}>
                        <RmField id={"search"} label={"Zoeken op naam of adres..."}
                                 onChange={this.handleSearchTextChange.bind(this)}
                                 iconName={"magnify"} value={this.state.searchText}
                                 marginOff={true}
                        />
                    </div>

                    <div className={"GuestlistScreen__categories"}>
                        {categories}
                    </div>
                    
                    {!this.state.loadingGuests && !anyResults &&
                        <ErrorMessage message={this.state.guestCount === 0 ? "Er zijn nog geen genodigden toegevoegd aan de lijst." : "Er zijn geen resultaten voor deze zoekopdracht."}/>
                    }
                </div>

                {anyResults &&
                <div className={"GuestlistScreen__exports"}>
                    <hr className={"GuestlistScreen__hr"}/>
                    <ArrowLink label={"Download lijst als PDF bestand"} href={`${window.API_URL}/guests_pdf`}
                               target={"_blank"} icon={<i className={"mdi mdi-file-pdf"}/>}
                    />
                    <ArrowLink label={"Download lijst als Excel bestand"} href={`${window.API_URL}/guests_excel`}
                               target={"_blank"} icon={<i className={"mdi mdi-file-excel"}/>}
                    />
                </div>
                }

            </PortalScreen>
        );
    }
}

GuestlistScreen.FILTER_ALL = 'all';
GuestlistScreen.FILTER_SENT = 'sent';
GuestlistScreen.FILTER_NON_SENT = 'nonsent';



// WEBPACK FOOTER //
// ./src/Portal/Guestlist/GuestlistScreen.js